import React from "react";

//interfaces
import { ISearchBarProps } from "../../../interfaces/search/search";

//components
import SearchBarButton from "./SearchBarButton";
import SearchBarInput from "./SearchBarInput";



const SearchBar = ({className = "", placeholderText, ariaLabel, searchInput, setSearchInput, onClickSearch, buttonLabel, buttonIconColor}: ISearchBarProps) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onClickSearch();
        }
    };

    return (
        <div className={`thrive-component-search-bar-wrapper ${className}`}>
            <SearchBarInput 
                placeholderText={placeholderText}
                ariaLabel={ariaLabel}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                handleKeyDown={handleKeyDown}
            />

            <SearchBarButton 
                onClickButton={onClickSearch}    
                buttonLabel={buttonLabel} 
                iconColor={buttonIconColor} 
            />
        </div>
    );
};

export default SearchBar;